import { SkinSelector } from '../../propertyPanel/CommonProperties/SkinSelector';

/**
 * 장바구니 컴포넌트 속성 정의
 * 에디터의 속성 패널에서 사용할 속성 그룹 및 컨트롤 정의
 */
const CartProperties = [
  {
    group: '외부 스킨',
    icon: 'palette',
    properties: [
      {
        name: 'componentProps.skin',
        label: '스킨 선택',
        control: SkinSelector,
        defaultValue: 'basic'
      }
    ]
  },
  {
    group: '기본 설정',
    properties: [
      {
        name: 'componentProps.title',
        label: '제목',
        control: 'TextField',
        defaultValue: '장바구니'
      },
      {
        name: 'componentProps.emptyText',
        label: '빈 장바구니 메시지',
        control: 'TextField',
        defaultValue: '장바구니가 비어있습니다.'
      },
      {
        name: 'componentProps.showStock',
        label: '재고 표시',
        control: 'Checkbox',
        defaultValue: true
      }
    ]
  },
  {
    group: '배송 설정',
    properties: [
      {
        name: 'componentProps.freeShippingLimit',
        label: '무료배송 기준금액',
        control: 'TextField',
        type: 'number',
        defaultValue: 50000,
        helpText: '이 금액 이상 구매시 무료배송'
      },
      {
        name: 'componentProps.shippingFee',
        label: '배송비',
        control: 'TextField',
        type: 'number',
        defaultValue: 3000
      }
    ]
  },
  {
    group: '스타일 설정',
    properties: [
      {
        name: 'style.backgroundColor',
        label: '배경색',
        control: 'ColorPicker',
        defaultValue: '#ffffff'
      },
      {
        name: 'style.padding',
        label: '여백',
        control: 'TextField',
        defaultValue: '20px'
      },
      {
        name: 'style.borderRadius',
        label: '모서리 둥글기',
        control: 'TextField',
        defaultValue: '8px'
      },
      {
        name: 'style.boxShadow',
        label: '그림자',
        control: 'TextField',
        defaultValue: '0 2px 4px rgba(0,0,0,0.1)'
      }
    ]
  }
];

export default CartProperties;